export default "__VITE_ASSET__BvIJ5DJX__"